module.exports = __webpack_public_path__ + "static/media/point-coin.ae25ec63.svg";